export type ModuloGerencial = 'menu' | 'ponto' | 'ferias' | 'ferias-lista' | 'secretarias' | 'oficios' | 'oficios-lista';

export interface ItemNavegacaoModuloGerencial {
  id: ModuloGerencial;
  rotulo: string;
}

export interface AtalhoMenuGerencial {
  id: ModuloGerencial;
  rotulo: string;
  icone: string;
  rota: string;
}

export function atalhosMenuGerencial(): AtalhoMenuGerencial[] {
  return [
    { id: 'ponto', rotulo: 'Ponto Eletrônico', icone: 'bi-clock', rota: '/registrador' },
    { id: 'ferias', rotulo: 'Gerenciador Férias', icone: 'bi-calendar2-week', rota: '/ferias' },
    { id: 'oficios', rotulo: 'Gerenciar Número de Documentos', icone: 'bi-file-earmark-text', rota: '/oficios' }
  ];
}

export function itensNavegacaoModuloGerencial(modulo: Exclude<ModuloGerencial, 'ponto'>): ItemNavegacaoModuloGerencial[] {
  if (modulo === 'menu') {
    return [{ id: 'menu', rotulo: 'Menu' }];
  }
  if (modulo === 'oficios' || modulo === 'oficios-lista') {
    return [
      { id: 'menu', rotulo: 'Menu' },
      { id: 'oficios', rotulo: 'Cadastro' },
      { id: 'oficios-lista', rotulo: 'Listagem' }
    ];
  }
  return [
    { id: 'menu', rotulo: 'Menu' },
    { id: 'ferias', rotulo: 'Férias' },
    { id: 'ferias-lista', rotulo: 'Listagem' },
    { id: 'secretarias', rotulo: 'Secretarias' }
  ];
}

export function rotaDoModuloGerencial(modulo: ModuloGerencial) {
  if (modulo === 'ponto') {
    return '/registrador';
  }
  if (modulo === 'oficios-lista') {
    return '/oficios/lista';
  }
  if (modulo === 'ferias-lista') {
    return '/ferias/lista';
  }
  if (modulo === 'secretarias') {
    return '/ferias/secretarias';
  }
  return modulo === 'menu' ? '/menu' : `/${modulo}`;
}

export function moduloGerencialPorUrl(url: string): ModuloGerencial {
  const partes = (url || '')
    .split('?')[0]
    .split('#')[0]
    .replace(/^\/+/, '')
    .split('/')
    .filter(Boolean);
  if (partes[0] === 'oficios' && partes[1] === 'lista') {
    return 'oficios-lista';
  }
  if (partes[0] === 'ferias' && partes[1] === 'lista') {
    return 'ferias-lista';
  }
  if (partes[0] === 'ferias' && partes[1] === 'secretarias') {
    return 'secretarias';
  }
  if (partes[0] === 'ferias' || partes[0] === 'oficios') {
    return partes[0];
  }
  return 'menu';
}
